const content = {
  component: 'BackCover',
  cssClass: 'back-cover',
  meta: {
    title: 'Your Tomorrow, Today',
    description: `You'll get the next issue on 18th August`,
    og: {
      type: 'website',
      title: 'Discover stories of innovation—read now',
      description: `in terms of what’s possible, utilising the latest technology to realise their strategic visions. Read issue 1 now, 
        and be inspired to grow your own business.`,
      image: require('../../assets/images/social/og_home.jpg')
    },
    twitter: {
      card: 'summary',
      title: 'Discover inspiring stories of how real businesses are innovating.',
      description: `Welcome to the first issue of Your Tomorrow, Today—a magazine all about business innovation. Discover stories of 
        how technology enables companies to grow, and be inspired to evolve your own business.`,
      site: '@Oracle',
      creator: '@Oracle',
      image: require('../../assets/images/social/twitter_home.jpg')
    }
  },
  title: 'Thank you for reading',
  maintitle: 'Your Tomorrow, Today',
  subtitle: `You'll get the next issue on 18th August`,
  heroImage: {
    preload: require('../../assets/images/backgrounds/page-one-pre.jpg'),
    loaded: require('../../assets/images/backgrounds/page-one.jpg'),
    thumbnail: require('../../assets/images/backgrounds/thumbnail-final-page.jpg')
  }
}

export default content;